import * as React from 'react';

// Utils
import { useTranslation } from 'react-i18next';
import { getMilageText } from '@src/shared/src/util/rentals';
// Constants
// Actions
// Models
import { RentalFareModel } from '@src/shared/src/models';
// Interfaces
// Interfaces
// Components
// Styles

type Props = {
  fare: RentalFareModel;
};

const RentalRate: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div className="rental-section">
      <div className="rental-label">{t('RentalCarExtras.label.rate')}</div>
      <div className="rental-option">
        <i className="icon-directions" />
        {getMilageText(props.fare)}
      </div>
    </div>
  );
};

export default RentalRate;
